import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useRolloverStore } from '@/store/use-rollover-store';
import { ref } from 'vue';
import PreviewResultsTableView from './PreviewResultsTableView.vue';

// Get store
interface Props {
  response: any[]
  open: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PreviewResultsDialog',
  props: {
    response: {},
    open: { type: Boolean }
  },
  emits: ["update:open"],
  setup(__props: any, { emit: __emit }) {

const rolloverStore = useRolloverStore()

const props = __props

const response = ref<any[]>(
  // @ts-ignore
  rolloverStore.rolloverResults
)

const handleClose = () => {
  emit('update:open', false)
  // Call the action on the store instance
  rolloverStore.clearRolloverResults();
}

const emit = __emit


return (_ctx: any,_cache: any) => {
  const _component_ScrollArea = _resolveComponent("ScrollArea")!
  const _component_DialogClose = _resolveComponent("DialogClose")!
  const _component_DialogFooter = _resolveComponent("DialogFooter")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: __props.open,
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => (emit('update:open', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogContent), { class: "w-[80vw] max-w-none sm:max-w-none bg-slate-50 overflow-y-auto" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogTitle), { class: "text-2xl" }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("Results", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_unref(DialogDescription), null, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" Review the Results Of Your Operation ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ScrollArea, { class: "overflow-y-auto max-h-[60vh] w-full" }, {
            default: _withCtx(() => [
              _createVNode(PreviewResultsTableView, { response: response.value }, null, 8, ["response"])
            ]),
            _: 1
          }),
          _createVNode(_component_DialogFooter, null, {
            default: _withCtx(() => [
              _createVNode(_component_DialogClose, { "as-child": "" }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("div", { class: "flex items-center justify-end" }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})